
import store from '@/store';

const virtualX7Info = {
  openTotal: 0, // 打开页面总次数
  carLock_switch: false, // carLock车锁是否开启
  carWindow_switch: false,
  tailgate_switch: false,
  carSearch_switch: false,
  engine_switch: false,
  rapidCooling_switch: false, // 极速降温
  extremeHeating_switch: false, // 极速升温
  ac: false, // 开关空调
  fall: false, // 极速降温
  heat: false, // 极速升温
  purify: false, // 空气净化
  front: false, // 前除霜
  after: false, // 后除霜
};

export const setVirtualX7Info = (key, data) => {
  const info = getVirtualX7Info();
  info[key] = data;
  localStorage.setItem('virtualX7Info', JSON.stringify(info));
  store.dispatch('setVirtualX7Info', info);
};

/**
 * 重置X7虚拟车控操作状态，(打开页面总次数，不变)
 */
export const resetVirtualX7Info = () => {
  const info = getVirtualX7Info();
  const { openTotal } = info;
  const resetInfo = {
    ...virtualX7Info,
    openTotal,
  };
  localStorage.setItem('virtualX7Info', JSON.stringify(resetInfo));
  store.dispatch('setVirtualX7Info', resetInfo);
};

export const getVirtualX7Info = () => {
  return localStorage.getItem('virtualX7Info') ? JSON.parse(localStorage.getItem('virtualX7Info')) : virtualX7Info;
};

export const getVirtualX7InfoItem = (key) => {
  return getVirtualX7Info()[key];
};
